import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./Header.css";

import { AccessTime, Menu, ExpandMore, ChevronRight, ExpandLess } from "@material-ui/icons";
import { Drawer, List, ListItem, ListItemText, Collapse } from "@material-ui/core";

// DATA FOR MEGA MENU
const PRODUCT_MENU = [
  {
    title: "Bakery Solutions",
    slug: "bakery-solutions",
    route: "/products/bakery-solutions",
  },
  {
    title: "Chocolates",
    slug: "chocolates",
    route: "/products/chocolates",
  },
  {
    title: "Cake Mixes",
    slug: "cake-mixes",
    route: "/products/cake-mixes",
  },
  {
    title: "Additives",
    slug: "additives",
    route: "/products/functional-additives",
  },
  {
    title: "Decorations",
    slug: "decorations",
    route: "/products/food-decorations",
  },
];

class Header extends Component {
  state = {
    drawerOpen: false,
    isScrolled: false,
    mobileProductOpen: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ drawerOpen: false });
    }
  }

  handleScroll = () => {
    this.setState({ isScrolled: window.scrollY > 50 });
  };

  navigateTo = (route) => {
    this.props.history.push(route);
    this.setState({ drawerOpen: false });
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  handleMobileProductClick = () => {
    this.setState((prevState) => ({ mobileProductOpen: !prevState.mobileProductOpen }));
  };

  render() {
    const { drawerOpen, isScrolled, mobileProductOpen } = this.state;

    return (
      <header className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="nav-row-2">
          <div className="nav-wrapper">
            {/* LOGO */}
            <div className="logo" onClick={() => this.navigateTo("/")}>
              <img src="/logo.png" alt="TR Food" />
            </div>

            {/* DESKTOP NAV */}
            <nav className="nav-links">
              {/* <div className="time-content">
                <AccessTime />
                <span>08:00 am - 08:30 pm</span>
              </div> */}

              <div className="link-btn" onClick={() => this.navigateTo("/")}>
                Home
              </div>
              <div className="link-btn" onClick={() => this.navigateTo("/about")}>
                About
              </div>
              <div className="link-btn" onClick={() => this.navigateTo("/products")}>
                Products
              </div>

              {/* <div className="link-btn dropdown-trigger">
                <span className="dropdown-trigger">
                  Products <ExpandMore style={{ fontSize: 16, verticalAlign: "middle" }} />
                </span>

                <div className="mega-menu">
                  {PRODUCT_MENU.map((item, index) => (
                    <div
                      key={index}
                      className="mega-column single-category"
                      onClick={() => this.navigateTo(item.route)}>
                      <h4>
                        <ChevronRight style={{ fontSize: 16, color: "#d4a574" }} />
                        {item.title}
                      </h4>
                    </div>
                  ))}
                </div>
              </div> */}

              <div className="link-btn" onClick={() => this.navigateTo("/applications")}>
                Applications
              </div>

              <div className="link-btn" onClick={() => this.navigateTo("/technical-support")}>
                Technical Support
              </div>
              <div className="link-btn contact-btn" onClick={() => this.navigateTo("/contact")}>
                Contact
              </div>
            </nav>

            {/* MOBILE ICON */}
            <div className="header-menu-bar">
              <Menu fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>

            <Drawer anchor="right" open={drawerOpen} onClose={() => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-header">
                  <img src="/logo.png" alt="logo" className="drawer-logo" />
                </div>

                <List component="nav">
                  <ListItem button onClick={() => this.navigateTo("/")}>
                    <ListItemText primary="Home" />
                  </ListItem>
                  <ListItem button onClick={() => this.navigateTo("/about")}>
                    <ListItemText primary="About Us" />
                  </ListItem>
                  <ListItem button onClick={() => this.navigateTo("/products")}>
                    <ListItemText primary="Products" />
                  </ListItem>

                  {/* MOBILE PRODUCT ACCORDION */}
                  {/* <ListItem button onClick={this.handleMobileProductClick}>
                    <ListItemText primary="Products" />
                    {mobileProductOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={mobileProductOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {PRODUCT_MENU.map((item, index) => (
                        <ListItem
                          key={index}
                          button
                          className="mobile-sub-item"
                          onClick={() => this.navigateTo(item.route)}>
                          <ListItemText
                            primary={item.title}
                            primaryTypographyProps={{
                              style: {
                                fontSize: "0.9rem",
                                color: "#d4a574",
                                fontWeight: "bold",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse> */}

                  <ListItem button onClick={() => this.navigateTo("/applications")}>
                    <ListItemText primary="Applications" />
                  </ListItem>
                  <ListItem button onClick={() => this.navigateTo("/contact")}>
                    <ListItemText primary="Contact" />
                  </ListItem>
                </List>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
